var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#00000064",
    height: "64px",
    width: "64px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 230.452 230.452",
    xmlSpace: "preserve",
    stroke: "#00000064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.452,81.522v-53.25h-53.283v15h27.676L183.506,64.61c-13.38-26.507-40.85-44.738-72.513-44.738 c-44.768,0-81.189,36.423-81.189,81.193c0,9.061,1.515,17.769,4.266,25.914L0,161.049l10.606,10.606l30.074-30.075 c14.049,24.285,40.294,40.672,70.312,40.672c19.689,0,37.76-7.049,51.833-18.751l47.079,47.077l10.606-10.606l-47.079-47.077 c11.702-14.072,18.752-32.142,18.752-51.831c0-7.305-0.985-14.38-2.803-21.119l26.07-26.068v27.644H230.452z M44.803,101.065 c0-36.499,29.692-66.193,66.189-66.193c27.596,0,51.29,16.98,61.212,41.038l-36.31,36.308L92.359,68.685l-46.113,46.116 C45.306,110.368,44.803,105.775,44.803,101.065z M177.184,101.065c0,36.496-29.693,66.188-66.191,66.188 c-25.919,0-48.393-14.982-59.25-36.734l40.618-40.62l43.535,43.531l40.741-40.738C176.984,95.436,177.184,98.227,177.184,101.065z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytic);
export default __webpack_public_path__ + "static/media/analytic.5a78c1ed2b4750cd13cf3c07f86ac345.svg";
export { ForwardRef as ReactComponent };